import { useCallback } from 'react';
import { useRouter } from 'next/router';

export const useDateFilterProcessing = <Type extends { dateFrom?: number | null, dateTo?: number | null }>() => {
  const { query: routeParams } = useRouter();

  return useCallback((
    filtersState: Type,
    filtersPayload: Type,
  ): Type => {
    const updatedPayload = { ...filtersPayload };

    if ('dateFrom' in routeParams) {
      const dateFrom = Number(routeParams.dateFrom);
      filtersState.dateFrom = dateFrom;
      updatedPayload.dateFrom = dateFrom;
    }

    if ('dateTo' in routeParams) {
      const dateTo = Number(routeParams.dateTo);
      filtersState.dateTo = dateTo;
      updatedPayload.dateTo = dateTo;
    }
    return updatedPayload;
  }, [routeParams]);
};
